<script setup>
import { ref, watch, defineProps } from 'vue';

const props = defineProps({
    visible: {
        type: Boolean,
        default: true,
    },
    boxTitle: String,
    closeHandle: Function,
    contentClass: {
        type: String,
        default: 'p-4',
    },
});

watch(() => props.visible, (val) => {

    if (val) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'visible';
    }

});

</script>

<template>

    <div class="fixed top-0 bottom-0 left-0 right-0 z-[110] bg-[#0204167A]" v-show="visible">
        <div class="flex flex-col fixed bottom-0 w-full max-h-[90%] bg-white rounded-t-lg">
            <div>
                <div class="flex justify-between p-4 pb-2 max-w-[768px] mx-auto">
                    <div class="flex-1">
                        <h5 class="text-lg font-bold text-left" v-if="boxTitle">{{ boxTitle }}</h5>
                    </div>
                    <div>
                        <button @click="(e) => { closeHandle(); }">
                            <svg fill="#0093C1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                style="width: 24px;height: 24px;">
                                <title>close</title>
                                <path
                                    d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="flex-1 overflow-y-auto scroll-smooth">
                <div class="max-w-[768px] mx-auto" :class="contentClass">
                    <slot></slot>
                </div>
            </div>
            <div class="relative z-10">
                <slot name="fixedBotton"></slot>
            </div>

        </div>
    </div>

</template>

<style scoped></style>
